import { cn } from './cn';

/** Marca do Grupo Central: o símbolo de círculos e o nome em duas linhas. */
export function Brand({ className, size = 'md' }: { className?: string; size?: 'sm' | 'md' }) {
  const sm = size === 'sm';
  return (
    <div className={cn('flex items-center text-fg', sm ? 'gap-1' : 'gap-2.5', className)}>
      <svg
        aria-hidden
        viewBox="0 0 32 32"
        className={cn('shrink-0', sm ? 'size-3.5' : 'size-8')}
        fill="currentColor"
      >
        <circle cx="16" cy="16" r="4.2" />
        <circle cx="16" cy="6.6" r="4" />
        <circle cx="24.2" cy="11.3" r="4" />
        <circle cx="24.2" cy="20.7" r="4" />
        <circle cx="16" cy="25.4" r="4" />
        <circle cx="7.8" cy="20.7" r="4" />
        <circle cx="7.8" cy="11.3" r="4" />
      </svg>
      <span className="flex flex-col leading-none">
        {/* Na versão pequena o "grupo" ficaria ilegível: só o nome. */}
        {!sm && <span className="text-center text-[0.65rem] tracking-[0.2em] opacity-70">– grupo –</span>}
        <span className={cn('font-light tracking-[0.08em]', sm ? 'text-[0.6rem]' : 'text-xl')}>CENTRAL</span>
      </span>
      <span className="sr-only">Grupo Central</span>
    </div>
  );
}

/** Só o símbolo — para a barra lateral recolhida. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={cn('size-8 shrink-0 text-fg', className)}
      fill="currentColor"
      role="img"
    >
      <title>Grupo Central</title>
      <circle cx="16" cy="16" r="4.2" />
      <circle cx="16" cy="6.6" r="4" />
      <circle cx="24.2" cy="11.3" r="4" />
      <circle cx="24.2" cy="20.7" r="4" />
      <circle cx="16" cy="25.4" r="4" />
      <circle cx="7.8" cy="20.7" r="4" />
      <circle cx="7.8" cy="11.3" r="4" />
    </svg>
  );
}
